import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["colorInput", "textInput"]

  connect() {
    // Initialize text input from color input value on page load
    this.syncFromColor()
  }

  syncFromColor() {
    if (this.hasColorInputTarget && this.hasTextInputTarget) {
      const colorValue = this.colorInputTarget.value
      this.textInputTarget.value = colorValue.toUpperCase()
      this.clearValidationError()
    }
  }

  syncFromText() {
    if (this.hasColorInputTarget && this.hasTextInputTarget) {
      let hexValue = this.textInputTarget.value.trim()
      
      // Add # prefix if missing
      if (hexValue && !hexValue.startsWith('#')) {
        hexValue = '#' + hexValue
      }
      
      // Convert to uppercase
      hexValue = hexValue.toUpperCase()
      
      // Validate hex format
      if (this.isValidHex(hexValue)) {
        this.colorInputTarget.value = hexValue
        this.clearValidationError()
      } else if (hexValue === '' || hexValue === '#') {
        // Allow empty value
        this.colorInputTarget.value = '#000000'
        this.clearValidationError()
      } else {
        // Show validation error
        this.showValidationError()
      }
    }
  }

  formatHex() {
    if (this.hasTextInputTarget) {
      let hexValue = this.textInputTarget.value.trim()
      
      // Add # prefix if missing
      if (hexValue && !hexValue.startsWith('#')) {
        hexValue = '#' + hexValue
      }
      
      // Convert to uppercase
      hexValue = hexValue.toUpperCase()
      
      // Update the text field with formatted value
      this.textInputTarget.value = hexValue
      
      // Trigger sync to validate and update color picker
      this.syncFromText()
    }
  }

  isValidHex(hex) {
    return /^#[0-9A-Fa-f]{6}$/.test(hex)
  }

  showValidationError() {
    if (this.hasTextInputTarget) {
      this.textInputTarget.classList.add('is-invalid')
    }
  }

  clearValidationError() {
    if (this.hasTextInputTarget) {
      this.textInputTarget.classList.remove('is-invalid')
    }
  }
}
